import React from 'react';
import { SendIcon } from 'lucide-react';
import { Button } from './common/Button';
import { mockData } from '../utils/mockData';
interface ReportFormProps {
  onClose: () => void;
  onSubmit: () => void;
}
export const ReportForm = ({
  onClose,
  onSubmit
}: ReportFormProps) => {
  const {
    caseNumber,
    location,
    incidentType,
    narrative
  } = mockData.reports.default;
  const handleSubmit = () => {
    onClose(); // Close the right panel first
    onSubmit(); // Open the affidavit modal
  };
  return <div className="space-y-xl" data-id="element-142">
      <div className="space-y-lg" data-id="element-143">
        <FormField label="Case Number" defaultValue={caseNumber} data-id="element-144" />
        <FormField label="Location" defaultValue={location} data-id="element-145" />
        <FormField label="Incident Type" defaultValue={incidentType} data-id="element-146" />
        <FormField label="Narrative" type="textarea" rows={8} defaultValue={narrative} data-id="element-147" />
      </div>
      <div className="flex gap-md" data-id="element-148">
        <Button variant="primary" icon={SendIcon} onClick={handleSubmit} data-id="element-149">
          Send Report
        </Button>
        <Button variant="secondary" onClick={onClose} data-id="element-150">
          Cancel
        </Button>
      </div>
    </div>;
};
const FormField = ({
  label,
  type = 'text',
  ...props
}) => <div className="space-y-sm" data-id="element-151">
    <label className="text-sm font-medium text-[#888888]" data-id="element-152">{label}</label>
    {type === 'textarea' ? <textarea className="w-full p-2 bg-[#2a2a2a] border border-[#444444] rounded-lg text-[#e0e0e0] focus:outline-none focus:border-[#4a90e2]" {...props} data-id="element-153" /> : <input type={type} className="w-full p-2 bg-[#2a2a2a] border border-[#444444] rounded-lg text-[#e0e0e0] focus:outline-none focus:border-[#4a90e2]" {...props} data-id="element-154" />}
  </div>;